import { brand } from '@brand';

/** Landing palette of the brand selected at build time. */
export const LANDING_CSS_VARS = brand.landing.cssVars;
export const landingColors = brand.landing.colors;
export const landingGradients = brand.landing.gradients;

/** Read a CSS variable value in the browser (SSR-safe fallback to hex map) */
export function landingCssVar(name: keyof typeof LANDING_CSS_VARS, fallback?: string): string {
  const varName = LANDING_CSS_VARS[name];
  if (typeof document === 'undefined') {
    return fallback ?? `var(${varName})`;
  }
  const value = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
  return value || (fallback ?? `var(${varName})`);
}

/** @deprecated Use landingColors.brandRampStart — kept for gradual migration */
export const BRAND_GRADIENT_FROM = landingColors.brandRampStart;
/** @deprecated Use landingColors.brandRampMid */
export const BRAND_GRADIENT_VIA = landingColors.brandRampMid;
/** @deprecated Use landingColors.brandRampEnd */
export const BRAND_GRADIENT_TO = landingColors.brandRampEnd;
